import { useState } from "react";

export const useInput = ()=>{
    const [state, setState] = useState("")
    const handleChange = (e)=>{
        e.preventDefault()
        setState(e.target.value)
    }

    return [state, handleChange, setState];
}